import {
    Datagrid,
    DateField,
    EmailField,
    List,
    TextField,
    ShowButton,
    useListContext,
} from 'react-admin';
import { Card, CardContent, Typography, Stack, TextField as MuiTextField } from '@mui/material';
import ClickableImageField from '../fields/ClickableImageField';
import { useEffect, useState } from 'react';

const UserFilterPanel = () => {
    const { filterValues, setFilters } = useListContext();
    const [usernames, setUsernames] = useState(filterValues.usernames || '');

    useEffect(() => {
        const delay = setTimeout(() => {
            const newFilters = { usernames };

            const filtersChanged = filterValues.usernames !== usernames;

            if (filtersChanged) {
                setFilters(newFilters, true);
            }
        }, 400);

        return () => clearTimeout(delay);
    }, [usernames]);


    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Фильтры
                </Typography>

                <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                    <MuiTextField
                        label="Usernames (через запятую)"
                        variant="outlined"
                        size="small"
                        value={usernames}
                        onChange={(e) => setUsernames(e.target.value)}
                        placeholder="user1,user2,user3"
                        fullWidth
                    />

                </Stack>
            </CardContent>
        </Card>
    );
};

export const UserList = (props) => (
    <List
        {...props}
        filters={false}
        sort={{ field: 'created_at', order: 'DESC' }}
    >
        <UserFilterPanel />

        <Datagrid rowClick="false">
            <ShowButton />
            <TextField source="id" />
            <ClickableImageField source="avatar" />
            <TextField source="name" />
            <TextField source="language" />
            <TextField source="sex" />
            <TextField source="username" />
            <EmailField source="email" />
            <DateField source="created_at" />
        </Datagrid>
    </List>
);
